import { CloseIcon, Filter } from '@dynamika-shared/ui/icons';
import {
  CustomDropdownProps,
  Dropdown,
} from '@dynamika-shared/ui/Dropdown/Dropdown';
import { ReactNode, useState } from 'react';

type DropdownTagProps<PF extends string> = CustomDropdownProps & {
  name: ReactNode | string;
  keyFilter: PF;
  active: boolean;
  closeTag: (name: PF) => void;
};

export function DropdownTag<PF extends string = string>(
  props: DropdownTagProps<PF>
) {
  const { name, keyFilter, active, closeTag, ...otherProps } = props;

  const [visible, setVisible] = useState(false);

  return active ? (
    <div className='sub-filter-container'>
      <div
        role='button'
        className='group/tag bg-waterLightHover50 hover:bg-waterLight flex h-[4rem] cursor-pointer items-center rounded-[32px] p-1'
      >
        <Dropdown
          {...otherProps}
          trigger={['click']}
          open={visible}
          className='h-[4rem] p-1'
          onOpenChange={(_, { source }) => {
            if (source === 'trigger') setVisible(!visible);
          }}
        >
          <div className='flex items-center justify-center gap-1'>
            <Filter
              height={20}
              width={20}
              className='group-hover/tag:text-[#1D8EF2]'
            />
            <div className='text-1424 text-black group-hover/tag:text-[#1D8EF2] whitespace-nowrap'>
              {name}
            </div>
            <CloseIcon
              width={20}
              height={20}
              className='rounded-[4px] hover:bg-water hover:text-dodgerBlue'
              onClick={e => {
                e.stopPropagation();
                closeTag(keyFilter);
              }}
            />
          </div>
        </Dropdown>
      </div>
    </div>
  ) : null;
}
